module.exports = __webpack_public_path__ + "img/home_img.da4f889a.png";